import { render, staticRenderFns } from "./Rentals.vue?vue&type=template&id=ba0e8fca&scoped=true"
import script from "./Rentals.vue?vue&type=script&lang=js"
export * from "./Rentals.vue?vue&type=script&lang=js"
import style0 from "./Rentals.vue?vue&type=style&index=0&id=ba0e8fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0e8fca",
  null
  
)

export default component.exports